var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 432.5H97.5C103.3 432.5 107.9 427.8 107.9 422.1V116C107.9 110.2 103.2 105.6 97.5 105.6H21.4C15.6 105.6 11 110.3 11 116V422.1C11 427.9 15.7 432.5 21.4 432.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.5 432.5H228.6C234.4 432.5 239 427.8 239 422.1V209.3C239 203.5 234.3 198.9 228.6 198.9H152.5C146.7 198.9 142.1 203.6 142.1 209.3V422.1C142 427.9 146.7 432.5 152.5 432.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5 432.5H359.6C365.4 432.5 370 427.8 370 422.1V46.3C370 40.5 365.3 35.9 359.6 35.9H283.5C277.7 35.9 273.1 40.6 273.1 46.3V422.1C273.1 427.9 277.7 432.5 283.5 432.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M490.6 152.7H414.5C408.7 152.7 404.1 157.4 404.1 163.1V422.1C404.1 427.9 408.8 432.5 414.5 432.5H490.6C496.4 432.5 501 427.8 501 422.1V163.1C501 157.4 496.3 152.7 490.6 152.7Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M490.6 455.3H21.4C15.6 455.3 11 460 11 465.7C11 471.4 15.7 476.1 21.4 476.1H490.5C496.3 476.1 500.9 471.4 500.9 465.7C500.9 460 496.3 455.3 490.6 455.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.fefce84f86effd74b77abeb2b1f93062.svg";
export { ForwardRef as ReactComponent };